export default __webpack_public_path__ + "static/media/correct9.b7a87c26.mp3";